<template>
  <div style="margin: 0 10px;">
    <el-upload ref="wordToHtml" :action="action" :headers="customHeaders" :disabled="loadingStatus"
               :show-file-list="false" :on-success="wordToHtml" :before-upload="onBeforeUpload">
      <el-button size="small" type="primary" :loading="loadingStatus">使用Word文件</el-button>
    </el-upload>
  </div>
</template>

<script>
import { Baseurl } from "@/api/api/api";

export default {
  name: "wordToHtml",
  data() {
    return {
      action: Baseurl + 'wordToHtmlController/wordToHtml',
      customHeaders: { token: localStorage.getItem("token") },
      loadingStatus: false,
    }
  },
  methods: {
    onBeforeUpload() {
      this.loadingStatus = true
      this.$message.success('正在识别文档，请稍候...')
    },
    wordToHtml(response) {
      const { code, data } = response
      this.loadingStatus = false
      if (code === 200) {
        this.$emit('done', data)
      } else {
        this.$message.closeAll()
        this.$message.error(data || '识别失败')
      }
    },
  },
}
</script>